"use client";

import React from "react";
import ApiDashboard from "@/components/ui/api-dashboard";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "@/lib/firebase";

export default function AccountLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if auth is initialized
    if (!auth) {
      setIsLoading(false);
      router.push("/auth/login?redirect=/account");
      return () => {};
    }
    
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoading(false);
      if (!user) {
        // Redirect to login page if not authenticated
        router.push("/auth/login?redirect=/account");
      }
    });

    return () => unsubscribe();
  }, [router]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return <ApiDashboard>{children}</ApiDashboard>;
}
